import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const CardGridStyles = makeStyles((theme) => ({
  container: {
    padding: "0 55px 50px 55px",
    margin: "10px 0 40px"
  },
  header: {
    textAlign: "center",
    marginBottom: 60
  },
  headline: {
    textAlign: "left"
  },
  linkContainer: {
    color: COLORS.ACCENT2,
    textDecoration: "underline",
    fontWeight: 600
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "1.25rem",
    "@media (max-width: 700px)": {
      display: "block",
      justifyContent: "initial"
    }
  },
  gridItem: {
    display: "flex"
  }
}));

export default CardGridStyles;
